{
  "DisplayAsLabel": "Afficher comme :",
  "ColorTileBackgroundLabel": "Couleur des carreaux :",
  "ColorTileTextLabel": "Couleur du texte :",
  "FitImageLabel": "Image d'ajustement",
  "DisplayTitleLabel": "Afficher la zone de texte du titre",
  "AutoValuePlaceholder": "[Auto]",
  "ImageUrlPlaceholder": "https:\/\/example.com\/image.png",
  "ImageUrlLabel": "URL de l'image :",
  "Black": "Noir",
  "White": "Blanc",
  "Blanc": "Blanc",
  "Smoke": "Fumée",
  "Grey": "Gris",
  "Battleship": "Battleship",
  "Aqua": "Aqua",
  "Blue": "Bleu",
  "Waters": "Eaux",
  "Sky": "Sky",
  "Akixi": "Akixi",
  "Midnight": "Minuit",
  "Pistachio": "Pistache",
  "Green": "Vert",
  "Forest": "Forêt",
  "Salmon": "Saumon",
  "Red": "Rouge",
  "Rosita": "Rosita",
  "Peach": "Pêche",
  "Orange": "Orange",
  "Clementine": "Clémentine",
  "Amarelo": "Amarelo",
  "Yellow": "Jaune",
  "Sunflower": "Tournesol",
  "Lilac": "Lilas",
  "Purple": "Violet",
  "Regal": "Regal",
  "Blush": "Blush",
  "Pink": "Rose",
  "Fuchsia": "Fuchsia",
  "Caribbean": "Caraïbes",
  "Teal": "Sarcelle",
  "Peacock": "Paon",
  "SimpleTextValue": "[Simple Text Value]",
  "ProgressRing": "Anneau de progression",
  "GradatedDial": "Cadran dégradé",
  "GlideSlope": "Pente de glissement",
  "Bullseye": "Bullseye",
  "BarGauge": "Jauge à barres",
  "ConeGauge": "Jauge à cône",
  "DashboardSpeedometerBlack": "Compteur de vitesse pour tableau de bord (noir)",
  "DashboardSpeedometerAmber": "Compteur de vitesse du tableau de bord (ambre)",
  "DashboardTemperatureGauge": "Jauge de température du tableau de bord",
  "DashboardFuelGauge": "Jauge à carburant du tableau de bord",
  "DashboardPowerGauge": "Jauge d'alimentation du tableau de bord",
  "DashboardColourGauge": "Jauge de couleur du tableau de bord",
  "GaugeFaceLabel": "Face de la jauge inversée :",
  "GaugeFaceDirection": "Inverser le sens de la jauge :",
  "MaxScaleLabel": "Échelle maximale :",
  "DisplayPreviewCaption": "Avant-première :",
  "DisplaySettings_SectionHeader": "Paramètres d'affichage",
  "NAME": "DisplaySettings",
  "VividSky": "Ciel vif",
  "ElectricIndigo": "Indigo électrique",
  "OxfordBlue": "Bleu Oxford",
  "Aquamarine": "Aigue-marine"
}